// extracted by mini-css-extract-plugin
module.exports = {"footer":"StickyFooter.styles_footer__1c9ZS","phone":"StickyFooter.styles_phone___zZja"};